import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiRequestService } from '../services/api-request.service';
import { FiltersService } from '../services/filters.service'


import { DisplayMessageToUserService } from './display-to-user-message.service';
import { PostOfficeInfo } from '../interfaces/post-office-info.interface'
import { MatchCities } from '../interfaces/match-cities.interface'
import { EventEmitter } from 'protractor';


@Injectable({
  providedIn: 'root'
})
export class MapRendererService {

  private drawOnMapSubject: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>(null);
  private focusMapOn: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private focusMapByManyPoints: BehaviorSubject<Array<[number, number]>> = new BehaviorSubject<Array<[number, number]>>(null);
  private isShowError: BehaviorSubject<{ isDisplay: boolean, messageText: string }> = new BehaviorSubject<{ isDisplay: boolean, messageText: string }>(null);
  private clearMapSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private focusAtSpecialOfficeFromListSubject: BehaviorSubject<PostOfficeInfo> = new BehaviorSubject<PostOfficeInfo>(null);
  private deleteScaledUpMarkerSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private hidePreviewSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private lastReceivedOffices: Array<any> = [];


  constructor(
    private API: ApiRequestService,
    private displayMessage: DisplayMessageToUserService,
    private filters: FiltersService,
    //private inputParser: UserInputParserService
  ) {
    this.displayMessage.getDisplayMessageOnMapSubject().asObservable().subscribe((newEvent: { isDisplay: boolean, messageText: string }) => {
      if (newEvent) {
        this.showError(newEvent.isDisplay, newEvent.messageText);
      }
    });

    this.filters.getSubjectFiltersAfterChange().subscribe(() => {
      if (this.lastReceivedOffices && this.lastReceivedOffices.length > 0) {
        this.drawOfficesOnMap(this.lastReceivedOffices);
      }
    });
  }


  public getHidePreviewSubject() {
    return this.hidePreviewSubject;
  }

  public hidePreview() {
    this.hidePreviewSubject.next(true);
  }

  public getDrawOfficesSubject(): BehaviorSubject<Array<any>> {
    return this.drawOnMapSubject;
  }

  // public drawOfficesOnMap(officesArray: Array<any>) {
  //   this.drawOnMapSubject.next(officesArray)
  // }
  public drawOfficesOnMap(officesArray: Array<any>) {
    if (officesArray) {
      console.log('Отримано відділень для малювання:', officesArray.length);
      
      this.lastReceivedOffices = officesArray; 
      const filteredOffices = this.filters.filterOfficesByEnabledFilters(officesArray);
      
      console.log('Після фільтрації залишилось:', filteredOffices ? filteredOffices.length : 0);
      this.drawOnMapSubject.next(filteredOffices);
    } else {
      console.log('Отримано порожній масив (null/undefined)');
    }
  }

  public focusMapOnPoint(point: [number, number], zoom: number) {
    this.focusMapOn.next({ point: [-(- point[0]), -(- point[1])], zoom: zoom })
    //  -(- number)  for converting to number ( + convert to string, - convert to number at JS )  
    // fix bug at leflet lib  
    // https://github.com/Leaflet/Leaflet/issues/2824#issuecomment-61249409
  }

  public getFocusMapOnPointSubject(): BehaviorSubject<any> {
    return this.focusMapOn;
  }

  public focusMapCenterAtMiddleOfManyPoints(pointsArray: Array<[number, number]>) {
    let convertedToNumber: Array<[number, number]>;

    convertedToNumber = pointsArray.map(point => {
      return [-(- point[0]), -(- point[1])]
    })
    //console.log(convertedToNumber)
    this.focusMapByManyPoints.next(convertedToNumber)
  }

  public getFocusMapCenterAtMiddleOfManyPointsSubject(): BehaviorSubject<Array<[number, number]>> {
    return this.focusMapByManyPoints;
  }

  public createPointsArrayFromOfficesArray(offices: Array<PostOfficeInfo>) {
    let points: Array<[number, number]> = offices.map((office: PostOfficeInfo) => {
      return [-(-office.LATTITUDE), -(-office.LONGITUDE)]
    })

    return points;
  }

  public showError(toShow: boolean, message: string = '') {
    this.isShowError.next({ isDisplay: toShow, messageText: message });
  }

  public getShowErrorSubject(): BehaviorSubject<{ isDisplay: boolean, messageText: string }> {
    return this.isShowError;
  }

  public getClearMapSubject(): BehaviorSubject<boolean> {
    return this.clearMapSubject;
  }

  public clearMap() {
    this.clearMapSubject.next(true);
  }


  public getFocusAtSpecialOfficeFromListSubject(): BehaviorSubject<PostOfficeInfo> {
    return this.focusAtSpecialOfficeFromListSubject;
  }

  public FocusAtSpecialOfficeFromList(officeToFocus: PostOfficeInfo) {
    this.focusAtSpecialOfficeFromListSubject.next(officeToFocus)
  }

  public getDeleteScaledUpMarkerSubject() {
    return this.deleteScaledUpMarkerSubject;
  }

  public deleteScaledUpMarker(isDelete: boolean = true) {
    this.deleteScaledUpMarkerSubject.next(isDelete)
  }

}
